import { render, staticRenderFns } from "./goodsMakeMethod.vue?vue&type=template&id=c3cc8664&scoped=true"
import script from "./goodsMakeMethod.vue?vue&type=script&lang=js"
export * from "./goodsMakeMethod.vue?vue&type=script&lang=js"
import style0 from "./goodsMakeMethod.vue?vue&type=style&index=0&id=c3cc8664&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cc8664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3cc8664')) {
      api.createRecord('c3cc8664', component.options)
    } else {
      api.reload('c3cc8664', component.options)
    }
    module.hot.accept("./goodsMakeMethod.vue?vue&type=template&id=c3cc8664&scoped=true", function () {
      api.rerender('c3cc8664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/goodsManage/goodsMakeMethod.vue"
export default component.exports